<template>
  <prompt-manager title="Prompts — Toutes les familles" />
</template>

<script>
import PromptManager from "@/components/llpr/PromptManager.vue";

export default {
  name: "AllPromptFamilies",
  components: {
    PromptManager,
  },
};
</script>
